module.exports = __webpack_public_path__ + "img/KB Bukopin Finance.23e6e1fa.png";